import {
  MAXIFY_REGION_NORTHERN_AMERICA,
  MAXIFY_REGION_EUROPE,
  MAXIFY_REGION_OCEANIA,
  MAXIFY_REGION_UNITED_KINGDOM,
  MAXIFY_REGION_NEW_ZEALAND,
  MAXIFY_REGION_ASIA,
} from './location';

export const KLAVIYO_COMPANY_ID_NA = 'M8RPxA';
export const KLAVIYO_COMPANY_ID_EU = 'Y9kvGQ';
export const KLAVIYO_COMPANY_ID_AU = 'UR6hve';
export const KLAVIYO_COMPANY_ID_UK = 'KdDNBS';
export const KLAVIYO_COMPANY_ID_NZ = 'SySbg6';

export const KLAVIYO_CREDS_REGION_MAP = {
  [MAXIFY_REGION_NORTHERN_AMERICA]: {
    companyId: KLAVIYO_COMPANY_ID_NA,
  },
  [MAXIFY_REGION_EUROPE]: {
    companyId: KLAVIYO_COMPANY_ID_EU,
  },
  [MAXIFY_REGION_OCEANIA]: {
    companyId: KLAVIYO_COMPANY_ID_AU,
  },
  [MAXIFY_REGION_UNITED_KINGDOM]: {
    companyId: KLAVIYO_COMPANY_ID_UK,
  },
  [MAXIFY_REGION_NEW_ZEALAND]: {
    companyId: KLAVIYO_COMPANY_ID_NZ,
  },
  [MAXIFY_REGION_ASIA]: {
    companyId: KLAVIYO_COMPANY_ID_NA,
  },
};

export const KLAVIYO_LIST_STOCK_NOTIFICATION = 'TxZ9eX';
export const KLAVIYO_LIST_NEWSLETTER = 'SeahJ8';
export const KLAVIYO_LIST_NEWSLETTER_UK = 'LBZiqT';
export const KLAVIYO_LIST_NEWSLETTER_NZ = 'TuYva8';

export const KLAVIYO_LIST_ID_REGION_MAP = {
  [MAXIFY_REGION_NORTHERN_AMERICA]: KLAVIYO_LIST_NEWSLETTER,
  [MAXIFY_REGION_EUROPE]: KLAVIYO_LIST_NEWSLETTER,
  [MAXIFY_REGION_OCEANIA]: KLAVIYO_LIST_NEWSLETTER,
  [MAXIFY_REGION_UNITED_KINGDOM]: KLAVIYO_LIST_NEWSLETTER_UK,
  [MAXIFY_REGION_NEW_ZEALAND]: KLAVIYO_LIST_NEWSLETTER_NZ,
};
